import { useEffect, useRef, useState } from 'react';

/* ══════════════════════════════════════════════════════════════════════════
   ELÁLLÁSI PIPA a kurzusvásárlás előtt (Plusz 1. kör, D.5 B változat)
   ─────────────────────────────────────────────────────────────────────────
   Ugyanaz, mint a landing src/components/ConsentDialog.jsx-e: alapból üres,
   kötelező pipa; a gomb csak bepipálva aktív, pipa nélküli kattintásra
   „A fizetéshez pipáld be.” A szerver (create-course-checkout) is ellenőriz
   (CONSENT_REQUIRED), és a beleegyezést a Stripe-metaadatba írja.
   ══════════════════════════════════════════════════════════════════════════ */

const CYAN = '#00D2C8';
export const CONSENT_TEXT = 'Kérem, hogy a megvásárolt tartalomhoz azonnal hozzáférjek, és tudomásul veszem, hogy ezzel a már elért digitális tartalomra elveszítem a 14 napos elállási jogomat.';

export default function ConsentDialog({ open, summary, onConfirm, onCancel, loading = false, error = '' }) {
  const ref = useRef(null);
  const [checked, setChecked] = useState(false);
  const [nudge, setNudge] = useState(false);

  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) { setChecked(false); setNudge(false); d.showModal(); }
    else if (!open && d.open) d.close();
  }, [open]);

  const go = () => { if (!checked) { setNudge(true); return; } onConfirm?.(); };
  const btn = (primary) => ({
    font: 'inherit', fontWeight: 700, fontSize: 15, padding: '12px 20px', borderRadius: 12, cursor: 'pointer',
    border: primary ? 'none' : '1px solid rgba(255,255,255,0.16)',
    background: primary ? (checked ? CYAN : 'rgba(255,255,255,0.08)') : 'transparent',
    color: primary ? (checked ? '#04201E' : 'rgba(255,255,255,0.45)') : '#fff',
    flex: '1 1 auto',
  });

  return (
    <dialog ref={ref} aria-labelledby="eg-consent-cim" onClose={onCancel} onClick={(e) => { if (e.target === ref.current) onCancel?.(); }}
      style={{ margin: 'auto', inset: 0, width: 'min(520px, calc(100vw - 32px))', padding: 0, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 16, background: '#111827', color: '#fff' }}>
      <div style={{ padding: 24, display: 'grid', gap: 14, fontFamily: "'Inter', system-ui, sans-serif" }}>
        <h2 id="eg-consent-cim" style={{ margin: 0, fontSize: 20 }}>Fizetés előtt</h2>
        {summary && <p style={{ margin: 0, fontSize: 14, color: 'rgba(255,255,255,0.6)' }}>{summary}</p>}
        <label style={{ display: 'grid', gridTemplateColumns: '22px 1fr', gap: 10, alignItems: 'start', fontSize: 14, lineHeight: 1.55, cursor: 'pointer' }}>
          <input type="checkbox" checked={checked} style={{ width: 18, height: 18, margin: '2px 0 0', accentColor: CYAN, cursor: 'pointer' }}
            onChange={(e) => { setChecked(e.target.checked); if (e.target.checked) setNudge(false); }}
            aria-describedby={nudge && !checked ? 'eg-consent-hint' : undefined} />
          <span>{CONSENT_TEXT}</span>
        </label>
        {nudge && !checked && <p id="eg-consent-hint" role="alert" style={{ margin: '-6px 0 0 32px', fontSize: 13, color: '#f87171' }}>A fizetéshez pipáld be.</p>}
        {error && <p role="alert" style={{ margin: 0, fontSize: 13, color: '#f87171' }}>{error}</p>}
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          <button type="button" aria-disabled={!checked} onClick={go} disabled={loading} style={btn(true)}>{loading ? 'Átirányítás…' : 'Tovább a fizetéshez'}</button>
          <button type="button" onClick={onCancel} style={btn(false)}>Mégse</button>
        </div>
      </div>
    </dialog>
  );
}
